<script>
  import { Line } from 'vue-chartjs'
  import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
  import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
  import { random } from '@/shared/utils'
  import DateFormatter from '../plugins/dateFormatter'
import dateFormatter from '../plugins/dateFormatter';

  export default {
    extends: Line,
    props: ['height', 'renderData'],
    data () {
      return {
        dates: [],
        ticksLimit : 0,
        filterDates : [],
        chartData : {},
        onedioTotalArray: [],
        onedioTotal: 0,
        overview:'',
        datasetArray: [],
        mycolor: '#000',
        facebookColor: '#023AA3',
        yandexColor: '#EF2E2E',
        relapColor: '#2DA87D',
        adxColor: '#FFA000',
        adformColor: '#BC4C9E',
        forColor: '',
        generalTotal: 0,
        selectedSites: '',
        onedioruDatas: '',
        onediocoDatas: '',
        onediocomDatas: '',
        overallData:[],
        maxValue:0,
      }
    },
    watch: {
      async renderData(newData, oldData){
        this.selectedSites = await this.$store.state.selectedSites
        this.filterDates = await this.$store.state.mainOverviewsData.filterDates
        this.filterDates=await this.filterDates.sort(this.filter_date_sort)
        this.overview=await this.$store.state.overview
        await this.changeChartData()
        /* await this.$store.dispatch('GENERAL_TOTAL',this.generalTotal) */
        await this.$events.fire('SET_GENERAL_TOTAL_OVERVIEW',this.generalTotal)
      }
    },
    async created(){
        this.selectedSites = await this.$store.state.selectedSites
        this.filterDates = await this.$store.state.mainOverviewsData.filterDates
        this.filterDates=await this.filterDates.sort(this.filter_date_sort)
        this.overview=await this.$store.state.overview
        this.overallData=await this.$store.state.mainOverviewsData.datas[0]
        await this.changeChartData()
        /* await this.$store.dispatch('GENERAL_TOTAL',this.generalTotal) */
        await this.$events.fire('SET_GENERAL_TOTAL_OVERVIEW',this.generalTotal)
    },
    async mounted () {
        await this.changeChartData();    
    },
    
    methods: {
      async changeChartData(){
          const brandSuccess = getStyle('--success') || '#4dbd74'
          const brandInfo = getStyle('--info') || '#20a8d8'
          const brandDanger = getStyle('--danger') || '#f86c6b'
          this.maxValue=0
          let dataInfo = false
          if(this.$store.state.mainOverviewsData.filterDates){
            this.chartData =await this.$store.state.mainOverviewsData.datas[0]
            this.onediocomDatas = await this.chartData.onediocomDatas
            this.onediocoDatas = await this.chartData.onediocoDatas
            this.onedioruDatas = await this.chartData.onedioruDatas
            this.filterDates = await this.$store.state.mainOverviewsData.filterDates
            this.filterDates=this.filterDates.sort(this.filter_date_sort)
            this.selectedSites=await this.$store.state.selectedSites
            this.overview=await this.$store.state.overview
            this.datasetArray = []
            this.generalTotal = 0
            this.selectedSites.forEach(async element => { 
              if(element === 'onediocom'){
                await this.filterSites(this.onediocomDatas,'onedio.com')
              }
              else if(element === 'onedioco'){
                await this.filterSites(this.onediocoDatas, 'onedio.co')
              }
              else if(element === 'onedioru'){
                await this.filterSites(this.onedioruDatas, 'onedio.ru')
              }
            });
            if(this.overview==="bounce_rate" && this.selectedSites){
              this.generalTotal/= await (this.selectedSites.length)
              if(this.filterDates){
                this.generalTotal/= await this.filterDates.length
              }
            }
            /* await this.$store.dispatch('GENERAL_TOTAL',this.generalTotal) */
            await this.$events.fire('SET_GENERAL_TOTAL_OVERVIEW',this.generalTotal)
            let maxValue = 0
            function getMaximum(params) {
              params = Number(params)
                if (params > maxValue){
                    maxValue = params;
                }
            }   
            Object.keys(this.datasetArray).forEach((item)=> {
              this.datasetArray[item].data.forEach(async (element) => {
              getMaximum(element)
              })
            })
            this.maxValue=maxValue
            this.changeChart();
            }
      },
      filterSites(site,siteName){
        let currency = ''
        this.overview=this.$store.state.overview
        let count=0
        let j=0
        this.onedioTotalArray = []
        this.onedioTotal=0
        let flag=0
        /* let total=0 */
        site.sort(this.date_sort)
        for(let date of this.filterDates){
          flag=0
          for(j=0;j<site.length;j++){
            let newdate=dateFormatter(site[j]['data_date'])
            this.labelName=this.overview
            this.forColor=this.overview
            this.labelName = siteName + ' ' + this.labelName
            if(newdate===date){
              flag=1
              if(this.overview==="pageview"){
                this.onedioTotal+=Number(site[j]['pageviews'])/1000
              }
              else if(this.overview==="user"){
                this.onedioTotal+=Number(site[j]['users'])/1000
              }
              else if(this.overview==="session"){
                this.onedioTotal+=Number(site[j]['session'])/1000
              }
              else if(this.overview==="bounce_rate"){
                this.onedioTotal+=Number(site[j]['bounce_rate'])
              }
              this.generalTotal+=Number(this.onedioTotal)
              /*  total+=Number(this.onedioTotal) */
              this.onedioTotalArray.push(this.onedioTotal.toFixed(2))
              this.onedioTotal = 0;
              break
            } 
          }
          if(!flag){
            this.onedioTotal = 0;
            this.generalTotal+=Number(this.onedioTotal)
            /* total+=Number(this.onedioTotal) */
            this.onedioTotalArray.push(this.onedioTotal.toFixed(2))
            
          }
        }
        if(siteName === 'onedio.com'){
          if(this.forColor === 'pageview'){
            this.mycolor = this.facebookColor
          }else if(this.forColor === 'user'){
            this.mycolor = this.yandexColor
          }else if(this.forColor === 'session'){
            this.mycolor = this.relapColor
          }else if(this.forColor === 'bounce_rate'){
            this.mycolor = this.adxColor
          }
        }
        else if(siteName === 'onedio.ru'){
          if(this.forColor === 'pageview'){
            this.mycolor = '#6a65d8'
          }else if(this.forColor === 'user'){
            this.mycolor = '#ca3e47'
          }else if(this.forColor === 'session'){
            this.mycolor = '#94DE00'
          }else if(this.forColor === 'bounce_rate'){
            this.mycolor = '#e8751a'
          }
        }
        else if(siteName === 'onedio.co'){  
          if(this.forColor === 'pageview'){
            this.mycolor = '#010059'
          }else if(this.forColor === 'user'){
            this.mycolor = '#ff7a8a'
          }else if(this.forColor === 'session'){
            this.mycolor = '#97de95'
          }else if(this.forColor === 'bounce_rate'){
            this.mycolor = '#ffd700'
          }
        }
        
        const dataSetItem = 
          {
            label: this.labelName,
            backgroundColor: hexToRgba(this.mycolor, 5),
            borderColor: this.mycolor,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: this.onedioTotalArray
          }
          /* let cached={index:indexname,data:dataSetItem,total:total}
          this.$store.dispatch('SET_CACHED_DATA',cached) */
        this.datasetArray.push(dataSetItem)
      },
      date_sort(a, b) {
        return new Date(a.data_date).getTime() - new Date(b.data_date).getTime();
      },
      filter_date_sort(a, b) {
        return new Date(a).getTime() - new Date(b).getTime();
      },
      changeChart(){
        const brandSuccess = getStyle('--success') || '#4dbd74'
        const brandInfo = getStyle('--info') || '#20a8d8'
        const brandDanger = getStyle('--danger') || '#f86c6b'
        this.renderChart({
          labels: this.filterDates,
          datasets: this.datasetArray 
        }, {
          tooltips: {
            enabled: false,
            custom: CustomTooltips,
            intersect: true,
            mode: 'index',
            position: 'nearest',
            callbacks: {
              labelColor: function (tooltipItem, chart) {
                return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
              }
            }
          },
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {
                maxTicksLimit: 18,
                stepSize: 1,
              },
              gridLines: {
                drawOnChartArea: true
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: false,
                maxTicksLimit: this.ticksLimit,
                stepSize: 1,
                max: this.maxValue
              },
              gridLines: {
                display: true
              }
            }]
          },
          elements: {
            point: {
              radius: 0,
              hitRadius: 10,
              hoverRadius: 4,
              hoverBorderWidth: 3
            }
          }
        })
      }
    }
  }
</script>
